import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Box, Container } from '@mui/material';

import SectionNavigation from '~/components/Common/Elements/SectionNavigation';
import SectionNavigationLayout from '~/components/Common/Elements/SectionNavigationLayout';
import { expandTabRoutes, preRegisterSpotlightRoutes } from '~/components/Common/Spotlight/SpotlightProvider';

import PageHeader from '../Common/Elements/PageHeader';

import { InvoiceToolsTab, invoiceToolsTabs, invoiceToolsTabsList } from './InvoiceToolsTabs';

preRegisterSpotlightRoutes(expandTabRoutes('/invoice-tools', 'Invoice Tools', invoiceToolsTabs));

export default function InvoiceToolsPageContainer() {
  const { tab } = useParams<{ tab: InvoiceToolsTab }>();
  const currentTab = invoiceToolsTabs[tab];
  const title = `Invoice Tools / ${currentTab.title}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Container maxWidth="xl">
        <PageHeader title={title} />

        <SectionNavigationLayout
          navigation={
            <SectionNavigation
              label="Invoice Tools sections"
              currentTab={tab}
              groups={[
                {
                  items: invoiceToolsTabsList.map((id) => ({
                    id,
                    label: invoiceToolsTabs[id].title,

                    href: `/invoice-tools/${id}`,
                  })),
                },
              ]}
            />
          }
        >
          <Box mt={4}>
            <Box component={currentTab.component} />
          </Box>
        </SectionNavigationLayout>
      </Container>
    </>
  );
}
